import React, { useEffect } from "react";
import MyForm from "../Home/MyForm/MyForm";
import MyNavbar from "../Home/MyNavbar/MyNavbar";
import "./home.css";
import HeaderMiniso from "./HeaderMiniso/HeaderMiniso";
import MyFooter from "./MyFooter/MyFooter";
import Entrega from "./Entrega";
import { Container } from "react-bootstrap";
import useUser from "../../hooks/useUser";
import WelcomeMinisoLover from "./WelcomeMinisoLover";
import NoService from "./NoService";
import { useNavigate } from "react-router-dom";

function Home() {
  const [
    dataUser,
    setDataUser,
    dataAdmin,
    setDataAdmin,
    initialDataUser,
    dataLocalStorage,
    setDataLocalStorage,
  ] = useUser();
  const { errorAptos } = dataUser;
  const navigate = useNavigate();
  useEffect(() => {
    if (
      dataLocalStorage?.email !== "default" &&
      dataLocalStorage?.email !== "" &&
      dataLocalStorage?.email !== undefined &&
      dataLocalStorage?.email !== null &&
      dataLocalStorage?.email !== true &&
      dataLocalStorage?.email !== false
    ) {
      //console.log("dataLocalStorage is TRUE:..",dataLocalStorage.email);
      navigate("/retry");
      //window.location.reload();
    } else {
      //console.log("dataLocalStorage is FALSE:..",dataLocalStorage.email);
    }
  }, [dataLocalStorage]);

  useEffect(() => {
    if (errorAptos) console.log("errorAptos:..", errorAptos);
    return;
  }, [errorAptos]);

  return (
    <div className="bg-white">
      <HeaderMiniso className="" />

      {/* <MyNavbar section={"register"} className=''/> */}
      {!errorAptos ? (
        <Container fluid className="bg-white w-100 ms-auto me-auto">
          {(dataUser.pageReload&&!dataUser.alreadyRegistered) ? <WelcomeMinisoLover /> : <MyForm />}
          
          {(dataUser.pageReload&&dataUser.alreadyRegistered) && 
          <h5 className="text-center text-danger m-2 p-2" >Usuario Actualmente Ya Registrado</h5>}
        </Container>
      ) : (
        <NoService />
      )}

      {/* <Entrega/> */}
      <MyFooter />
    </div>
  );
}

export default Home;
